import { AnalyticsTrackEvent, TrackLiveChatStartedInput } from '@/types'

export const createLiveChatClicked = (): Extract<AnalyticsTrackEvent, { object: 'Live Chat'; action: 'Clicked' }> => {
  const event: Extract<AnalyticsTrackEvent, { object: 'Live Chat'; action: 'Clicked' }> = {
    object: 'Live Chat',
    action: 'Clicked',
    properties: {},
  }
  return event
}

export const createLiveChatStarted = ({
  firstName,
  lastName,
  email,
}: TrackLiveChatStartedInput): Extract<AnalyticsTrackEvent, { object: 'Live Chat'; action: 'Started' }> => {
  const event: Extract<AnalyticsTrackEvent, { object: 'Live Chat'; action: 'Started' }> = {
    object: 'Live Chat',
    action: 'Started',
    properties: {},
  }

  event.context = {
    ...event.context,
    traits: {
      ...event.context?.traits,
      hashed_email: email,
      hashed_first_name: firstName,
      hashed_last_name: lastName,
    },
  }

  return event
}

export const createLiveChatEnded = (): Extract<AnalyticsTrackEvent, { object: 'Live Chat'; action: 'Ended' }> => {
  const event: Extract<AnalyticsTrackEvent, { object: 'Live Chat'; action: 'Ended' }> = {
    object: 'Live Chat',
    action: 'Ended',
    properties: {},
  }
  return event
}
